export const FARM_PAYMENT_CATEGORY_OTHER_GOVERNMENT = "other_government";
export const FARM_PAYMENT_CATEGORY_MISCELLANEOUS = "miscellaneous";

/** Revenue Dashboard readonly row labels (ClickUp #86e1jqnut). */
export const REVENUE_LABEL_OTHER_GOVERNMENT_PAYMENTS = "Other Government Payments";
export const REVENUE_LABEL_MISCELLANEOUS_PROGRAM_PAYMENTS = "Miscellaneous Program Payments";

export const FARM_PAYMENT_CATEGORIES = [
  { value: FARM_PAYMENT_CATEGORY_OTHER_GOVERNMENT, label: "Other Government Payments" },
  { value: FARM_PAYMENT_CATEGORY_MISCELLANEOUS, label: "Miscellaneous Payments" },
];

export const FARM_PAYMENT_CATEGORY_VALUES = FARM_PAYMENT_CATEGORIES.map((category) => category.value);

export const isFarmPaymentCategory = (value) => FARM_PAYMENT_CATEGORY_VALUES.includes(value);

export const getFarmPaymentCategoryLabel = (value) =>
  FARM_PAYMENT_CATEGORIES.find((category) => category.value === value)?.label ?? value ?? "";

const normalizeCommodity = (value) => (value || "").trim().toLowerCase();

export const sumFarmPaymentsByCategory = (payments, category, commodityName = null) =>
  (payments || [])
    .filter((payment) => {
      if (payment.payment_category !== category) return false;
      if (commodityName == null) return true;
      const paymentCommodity = payment.commodity_name;
      if (!paymentCommodity) return false;
      return normalizeCommodity(paymentCommodity) === normalizeCommodity(commodityName);
    })
    .reduce((total, payment) => total + Number(payment.payment_amount ?? 0), 0);

export const computeFarmPaymentTotals = (payments, commodityName = null) => ({
  otherGovernment: sumFarmPaymentsByCategory(
    payments,
    FARM_PAYMENT_CATEGORY_OTHER_GOVERNMENT,
    commodityName
  ),
  miscellaneous: sumFarmPaymentsByCategory(payments, FARM_PAYMENT_CATEGORY_MISCELLANEOUS, commodityName),
});
